import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {proposalsUrl, proposalsUserUrl} from '../api-url';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {AuthService} from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProposalsResolver implements Resolve<any> {

  constructor(private http: HttpClient, private authService: AuthService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const userId = this.authService.getUserId();
    return this.http.get<any>(`${proposalsUserUrl}/` + userId).pipe(
      map(data => data)
    );
  }
}
